// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/long_description.scss
// module id = 95
// module chunks = 0